var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-3@l uk-width-1-2@m uk-width-1-1@s uk-flex-first uk-padding-small uk-height-medium"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }